import { Box } from '@mui/material';

import AuthLayout from '@layouts/authLayout/Auth.layout';
import AdminLogin from '@components/login/admin';

const AdminLoginPage = () => {
  return (
    <Box display="flex" width="100%">
      <AuthLayout>
        <AdminLogin />
      </AuthLayout>
    </Box>
  );
};

export default AdminLoginPage;
